var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 11,
    viewBox: "0 0 3 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49103 4.75117C1.42158 4.75005 1.34127 4.75002 1.24219 4.75002C0.827974 4.75002 0.492188 4.41423 0.492188 4.00002C0.492188 3.5858 0.827974 3.25002 1.24219 3.25002L1.27663 3.25001C1.48175 3.24993 1.70354 3.24984 1.89076 3.27501C2.11008 3.3045 2.39027 3.38033 2.62607 3.61613C2.86187 3.85193 2.93771 4.13212 2.96719 4.35145C2.99236 4.53866 2.99228 4.76046 2.9922 4.96557L2.99219 10C2.99219 10.4142 2.6564 10.75 2.24219 10.75C1.82797 10.75 1.49219 10.4142 1.49219 10V5.00002C1.49219 4.90094 1.49215 4.82063 1.49103 4.75117Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99219 0C1.4399 0 0.992188 0.447715 0.992188 1C0.992188 1.55228 1.4399 2 1.99219 2H2.00117C2.55345 2 3.00117 1.55228 3.00117 1C3.00117 0.447715 2.55345 0 2.00117 0H1.99219Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.7e4f8fff002edd5bc13f4695ff82a730.svg";
export { ForwardRef as ReactComponent };